module.exports = __webpack_public_path__ + "static/media/map-marked-alt.f66b1293.svg";